const data = {
  logo: "/assets/paomakeup/images/pm-beauty-studio-logo.jpeg",
  title: "PM Beauty Studio",
  description: "Somos un equipo de profesionales enfocados en la belleza. Hemos creado este centro ofreciendo la mejor asistencia en el área de maquillaje, peinados y otros servicios que demanda la mujer de hoy en día.",
  aboutus_title: "¿Quiénes Somos?",
  aboutus_image: "assets/paomakeup/images/paomakeup-person.jpg",
  aboutus_body: "<p>Somos un equipo de profesionales enfocados en la belleza. Hemos creado este centro ofreciendo la mejor asistencia en el área de maquillaje, peinados y otros servicios que demanda la mujer de hoy en día.</p>" +
      "<p>Nos enfocamos en realzar la belleza de manera natural, ayudando a nuestros clientes a sentirse a gusto con su imagen para cualquier ocasión. Utilizamos productos de calidad adecuados a su necesidad, con el objetivo de proporcionarles el mejor de los servicios con un trato personalizado.</p>" +
      "<h4>Nuestro compromiso es ayudarte a realzar tu belleza para que salgas a brillar!</h4>" +
      "<h5>Paola Muñoz</h5>",
  month_offers: [
    {
      title: "Promoción de Mes",
      description: "¡Aprovecha nuestra promoción de mes! Descubre nuestros servicios y disfruta de un 10% de descuento en tu primera visita.",
      image: "assets/paomakeup/ofertas/10-porciento-de-descuento-primera-vez.jpg"
    },
    {
      title: "Promoción de Mes",
      description: "¡Aprovecha nuestra promoción de mes! Descubre nuestros servicios y disfruta de un 10% de descuento en tu primera visita.",
      image: "assets/paomakeup/ofertas/te-casas-cotiza-con-nosotros.jpg"
    },
  ],
  our_services: [
    {
      title: "Permanent Makeup",
      service_slug: 'permanent-makeup',
      description: "¿Te imaginas no tener que maquillarte a diario? Esto es posible con nuestros procedimientos de maquillaje semipermanente con aspecto natural.",
      image: "assets/paomakeup/images/services/microblading.jpg"
    },
    {
      title: "Beauty Makeup",
      service_slug: 'beauty-makeup',
      description: "Servicio de Maquillaje Profesional de la mano de nuestras profesionales, ideal para cualquier ocasión en la que quieras realzar tu belleza.",
      image: "assets/paomakeup/images/services/service-makeup.jpeg"
    },
    {
      title: "Beauty Hair",
      service_slug: 'beauty-hair',
      description: "Deja tu cabello en manos expertas y cuidados profesionales en nuestra área de peluquería, te brindamos estos servicios.",
      image: "assets/paomakeup/images/services/service-salon.jpeg"
    },
    {
      title: "Beauty Lashes",
      service_slug: 'beauty-lashes-brows',
      description: "Lista para una mirada impactante?? Alarga y destaca tus pestañas, con cualquiera de estos servicios te verás fabulosa.",
      image: "assets/paomakeup/images/services/beauty-lashes.jpg"
    },
    {
      title: "Beauty Brows",
      service_slug: 'beauty-lashes-brows',
      description: "Las cejas son el marco del rostro, permite que diseñemos la forma que mejor se adapta a ti para lograr Cejas Perfectas y una mirada impactante!.",
      image: "assets/paomakeup/images/services/beauty-brows.jpg"
    },
    {
      title: "Beauty Nails",
      service_slug: 'beauty-nails',
      description: "Relájate al mismo tiempo que hidratas y cuidas tus manos y pies con nuestros productos naturales provenientes de rosas.",
      image: "assets/paomakeup/images/services/service-beauty-nails.jpg"
    }
  ],
  permanent_makeup_services: [
    {
      name: "Microblading",
      service_slug: 'perfect-brows',
      description: "<div>"+
        "<p>Es la &uacute;ltima t&eacute;cnica dentro de la industria del maquillaje permanente en la creaci&oacute;n de dise&ntilde;o de cejas pelo a pelo, m&eacute;todo de f&aacute;cil realizaci&oacute;n, r&aacute;pida cicatrizaci&oacute;n y de aspecto muy natural.</p>"+
        "<p>Indicado para aquellas personas que desean rellenar algunas zonas y definir naturalmente sus cejas.</p>"+
        "<ul>"+
        "<li>⌛️ Duraci&oacute;n: 1 a&ntilde;o aproximadamente</li>"+
        "<li>💵 Costo: RD$12,000</li>"+
        "<li>📆 Retoques: 30 d&iacute;as: RD$3,000 - 45-60 d&iacute;as: RD$4,000</li>"+
        "<li>⏰ Tiempo del proceso: 1.5 horas</li>"+
        "<li>😩 Nivel de Dolor: 2/10 (se utiliza anestesia t&oacute;pica)</li>"+
        "</ul>"+
      "</div>",
      image: "assets/paomakeup/images/services/permanent-makeup-2.jpg"
    },
    {
      name: "Micropigmentación de Cejas",
      service_slug: 'shade-digital',
      description: "<div>"+
        "<p>También llamado Powder Brows (efecto tipo polvo). El sombreado semipermanente de cejas, tambi&eacute;n llamado micropigmentaci&oacute;n, es una t&eacute;cnica a trav&eacute;s de la cual se introducen pigmentos a nivel epid&eacute;rmico de forma indolora creando un efecto sombreado en sus cejas.</p>"+
        "<p>Ideal para personas con pieles grasas o con cicatrizaci&oacute;n queloides.</p>"+
        "<ul>"+
        "<li>⌛️ Duraci&oacute;n: 1 a&ntilde;o aproximadamente</li>"+
        "<li>💵 Costo: RD$10,000</li>"+
        "<li>📆 Retoques: 30 d&iacute;as: RD$3,000 - 45-60 d&iacute;as: RD$4,000</li>"+
        "<li>⏰ Tiempo del proceso: 1.5 horas</li>"+
        "<li>😩 Nivel de Dolor: 2/10 (se utiliza anestesia t&oacute;pica)</li>"+
        "</ul></div>",
      image: "assets/paomakeup/images/services/micropigmentacion-cejas.jpg"
    },
    {
      name: "Perfect Brows",
      service_slug: 'perfect-brows',
      description: "<div>"+
        "<p>T&eacute;cnica combinada de microblanding y powder brows. Esta t&eacute;cnica combina el pelo a pelo con el sombreado digital en degradado, ideal para las que les gusta el efecto de cejas m&aacute;s pobladas y definidas.</p>"+
        "<p>Adecuado para pieles oleosas y personas que tienen cejas poco pobladas o anteriormente tatuadas.</p>"+
          "<ul>"+
            "<li>⌛️ Duraci&oacute;n: 1-2 a&ntilde;os aproximadamente</li>"+
            "<li>💵 Costo: RD$15,000</li>"+
            "<li>📆 Retoques: 30 d&iacute;as: RD$3,000 - 45-60 d&iacute;as: RD$4,000</li>"+
            "<li>⏰ Tiempo del proceso: 1.5 horas</li>"+
            "<li>😩 Nivel de Dolor: 2/10 (se utiliza anestesia t&oacute;pica)</li>"+
          "</ul>"+
        "</div>",
      image: "assets/paomakeup/images/services/permanent-makeup-7.jpeg"
    },
    {
      name: "Microshading",
      service_slug: 'microshading',
      description: "<div>"+
        "<p>Cobertura de Tatuajes. Con esta t&eacute;cnica neutralizamos el color de su tatuaje anterior y luego procedemos a pigmentar la piel con el tono y forma deseados.</p>"+
        "<p>NOTA: El procedimiento anterior debe haber aclarado al menos un 70% y ser evaluada para determinar si aplica a esta t&eacute;cnica.</p>"+
        "<ul>"+
          "<li>⌛️ Duraci&oacute;n: 1 a&ntilde;o aproximadamente</li>"+
          "<li>💵 Costo: RD$18,000</li>"+
          "<li>📆 Retoques: 30 d&iacute;as: RD$3,000 - 45-60 d&iacute;as: RD$4,000</li>"+
          "<li>⏰ Tiempo del proceso: 1.5 horas</li>"+
          "<li>😩 Nivel de Dolor: 2/10 (se utiliza anestesia t&oacute;pica) (puede que sea necesario realizar 2 retoques)</li>"+
        "</ul>"+
      "</div>",
      image: "assets/paomakeup/images/services/permanent-makeup-4.jpg"
    },
    {
      name: "Micropigmentación de Labios",
      service_slug: 'micropigmentacion-labios',
      description: "<div>"+
        "<p>En los labios, la micropigmentaci&oacute;n sirve para equilibrar peque&ntilde;as asimetr&iacute;as, redise&ntilde;ar el contorno que se pierde con el paso del tiempo y colorear la mucosa, ayudando a mantener los labios jugosos.</p>"+
        "<p>Si sus labios tienen pigmentaci&oacute;n oscura se debe realizar primero una neutralizaci&oacute;n. (A evaluar).</p>"+
        "<ul>"+
          "<li>⌛️ Duraci&oacute;n: 1-2 a&ntilde;os aproximadamente</li>"+
          "<li>💵 Costo: RD$10,000</li>"+
          "<li>📆 Retoques: 30 d&iacute;as: RD$3,000 - 45-60 d&iacute;as: RD$4,000</li>"+
          "<li>⏰ Tiempo del proceso: 1.5 horas</li>"+
          "<li>😩 Nivel de Dolor: 2/10 (se utiliza anestesia t&oacute;pica).</li>"+
        "</ul>"+
      "</div>",
      image: "assets/paomakeup/images/services/permanent-makeup-5.jpg"
    },
    {
      name: "Neutralización de Labios",
      service_slug: 'neutralizacion-labios',
      description: "<div>"+
        "<p>Si tiene labios ocuros, esta t&eacute;cnica tiene como objetivo unificar el tono de los labios, creando un color uniforme.</p>"+
        "<ul>"+
          "<li>⌛️ Duraci&oacute;n: 1-2 a&ntilde;os aproximadamente</li>"+
          "<li>💵 Costo: RD$10,000</li>"+
          "<li>📆 Retoques: 30 d&iacute;as: RD$3,000 - 45-60 d&iacute;as: RD$4,000</li>"+
          "<li>⏰ Tiempo del proceso: 1.5 horas</li>"+
          "<li>😩 Nivel de Dolor: 2/10 (se utiliza anestesia t&oacute;pica)</li>"+
        "</ul>"+
      "</div>",
      image: "assets/paomakeup/images/services/permanent-makeup-6.jpg"
    }
  ],
  our_services_price_title: "Nuestros Servicios y Precios",
  our_services_price_description: "Precios de nuestros servicios de maquillaje, cejas, pestañas, uñas, cabello, rostro, cuerpo, belleza, spa, estetica.",
  our_services_price_keywords: "servicios, precios, maquillaje, cejas, pestañas, uñas, cabello, rostro, cuerpo, belleza, spa, estetica, santo domingo, república dominicana",
  our_services_price: [
    {
      service_name: 'Beauty Makeup',
      service_slug: 'beauty-makeup',
      service_image: 'assets/paomakeup/images/services/service-makeup.jpeg',
      bgcolor: 'card6',
      sub_services: [
        {
          sub_service_name: 'Maquillajes',
          description: 'Maquillaje para ocasiones especiales, fiestas, eventos y más.',
          services: [
            { name: 'Maquillaje Express', price: 'RD$ 1,500' },
            { name: 'Maquillaje Soft', price: 'RD$ 2,000' },
            { name: 'Maquillaje Glam', price: 'RD$ 2,500' },
            { name: 'Maquillaje de Novia *Piel Blindada', price: 'RD$ 4,000' },
            { name: 'Maquillaje Sesion de Fotos * Piel Blindada', price: 'RD$ 4,000' },
            { name: 'Maquillaje Caballeros', price: 'RD$ 800' },
            { name: 'Maquillaje de Cejas', price: 'RD$ 500' },
            { name: 'Maquillaje de Fantasia Sencillo', price: 'RD$ 3,500' },
            { name: 'Maquillaje de Fantasia Elaborado', price: 'RD$ 4,500' },
          ]
        },
        {
          sub_service_name: 'Maquillaje de ojos',
          description: 'Maquillaje especializado en ojos, ideal para realzar tu mirada.',
          services: [
            { name: 'Maquillaje de Ojos Sencillo*Sin Pestañas', price: 'RD$ 1,200' },
            { name: 'Maquillaje de Ojos con Pestañas', price: 'RD$ 1,500' },
            { name: 'Maquillaje de Ojos Express (delineado y cejas)', price: 'RD$ 950' }
          ]
        },
        {
          sub_service_name: 'Maquillaje para Niñas',
          description: 'Maquillaje especial para niñas, adaptado a su edad y estilo.',
          services: [
            { name: 'Maquillaje Niñas Grandes (hasta 13 años)', price: 'RD$ 1,200' },
            { name: 'Maquillaje Niñas Pequeñas (5-10 años)', price: 'RD$ 800' }
          ]
        }
      ]
    },
    {
      service_name: 'Permanent Makeup',
      service_slug: 'permanent-makeup',
      service_image: 'assets/paomakeup/images/services/microblading.jpg',
      bgcolor: 'card1',
      sub_services: [
        {
          sub_service_name: 'Cejas',
          description: 'Técnica pelo a pelo, ideal para rellenar zonas y definir naturalmente tus cejas.',
          services: [
            { name: 'Micropigmentación de Cejas', price: 'RD$ 10,000' },
            { name: 'Microblading', price: 'RD$ 12,000' },
            { name: 'Perfect Brows (Microblading + Micropigmentación de Cejas)', price: 'RD$ 15,000' },
            { name: 'Microshading (Cobertura Procesos Anteriores)', price: 'RD$ 18,000' },
          ]
        },
        {
          sub_service_name: 'Labios',
          description: 'Técnica para equilibrar asimetrías y colorear la mucosa de los labios.',
          services: [
            { name: 'Neutralizacion de Labios', price: 'RD$ 10,000' },
            { name: 'Micropigmentación de Labios', price: 'RD$ 10,000' },
            { name: 'Neutralizacion + Micropigmentacion de Labios', price: 'RD$ 15,000' },
          ]
        },
        {
          sub_service_name: 'Retoques',
          description: 'Cada cierto tiempo debes retocar tus cejas y labios.',
          services: [
            { name: 'Retoque a los 30 días', price: 'RD$ 3,000'},
            { name: 'Retoque a los 45-60 días', price: 'RD$ 4,000'},
          ]
        },
      ]
    },
    {
      service_name: 'Beauty Lashes & Brows',
      service_slug: 'beauty-lashes-brows',
      service_image: 'assets/paomakeup/images/services/beauty-lashes.jpg',
      bgcolor: 'card2',
      sub_services: [
        {
          sub_service_name: 'Cejas',
          services: [
            { name: 'Brow Lamination - Laminado de Cejas', price: 'RD$ 3,000' },
            { name: 'Cejas Perfectas', price: 'RD$ 1,200' },
            { name: 'Cejas Perfectas by PM', price: 'RD$ 2,000' },
            { name: 'Depilación de Barbilla Cera/Hilo', price: 'RD$ 500' },
            { name: 'Depilación de Cejas con Hilo (Limpieza)', price: 'RD$ 500' },
            { name: 'Depilación de Cejas con Hilo by PM', price: 'RD$ 1,200' },
            { name: 'Depilación de Cejas con Pinza', price: 'RD$ 500' },
            { name: 'Depilación de Piernas Completa', price: 'RD$ 1,200' },
            { name: 'Depilación Rostro', price: 'RD$ 1,500' },
            { name: 'Perfilado de Cejas con Navaja', price: 'RD$ 400' },
            { name: 'Tintado de Cejas', price: 'RD$ 700' },
            { name: 'Tintado de Cejas by PM', price: 'RD$ 1,000' }
          ]
        },
        {
          sub_service_name: 'Pestañas',
          services: [
            { name: 'Lash Lift (Realce de Pestañas)', price: 'RD$ 3,000' },
            { name: 'Lash Lift by PM', price: 'RD$ 4,000' },
            { name: 'Postura de Pestañas del Cliente', price: 'RD$ 350' },
            { name: 'Pestañas Corridas', price: 'RD$ 500' },
            { name: 'Pestañas Individuales por Grupo', price: 'RD$ 995' },
            { name: 'Pestañas Pelo a Pelo', price: 'RD$ 3,000' },
            { name: 'Pestañas Pelo a Pelo by PM', price: 'RD$ 4,000' },
            { name: 'Pestañas Volumen Ruso', price: 'RD$ 4,000' },
            { name: 'Pestanas Extra Volumen Ruso', price: 'RD$ 5,000' },
            { name: 'Pestañas Volumen Ruso by PM', price: 'RD$ 5,000' },
            { name: 'Pestañas Extra Volumen Ruso by PM', price: 'RD$ 6,000' },
            { name: 'Pestañas Volumen Tecnologico', price: 'RD$ 3,000' },
            { name: 'Pestañas Volumen Tecnologico by PM', price: 'RD$ 4,000' },
            { name: 'UV Lashes - Pelo a Pelo', price: 'RD$ 4,000' },
            { name: 'UV Lashes - Volumen Tecnologico', price: 'RD$ 4,500' },
            { name: 'UV Lashes - Volumen Ruso', price: 'RD$ 5,000' },
            { name: 'UV Lashes - Extra Volumen Ruso', price: 'RD$ 6,000' },
            { name: 'Retiro de Pestañas Pelo a Pelo', price: 'RD$ 800-1,500' }
          ]
        },
        {
          sub_service_name: 'Retoques',
          services: [
            { name: 'Retoque de Pestañas Pelo a Pelo 1 semana', price: 'RD$ 1,500' },
            { name: 'Retoque de Pestañas Pelo a Pelo 2 semanas', price: 'RD$ 2,000' },
            { name: 'Retoque de Pestañas Pelo a Pelo 3 semanas', price: 'RD$ 2,500' },
            { name: 'Retoque de Petañas Volumen Ruso 1 semana', price: 'RD$ 2,000' },
            { name: 'Retoque de Petañas Volumen Ruso 2 semanas', price: 'RD$ 2,500' },
            { name: 'Retoque de Petañas Volumen Ruso 3 semanas', price: 'RD$ 3,000' },
            { name: 'Retoque de Petañas Volumen Tecnologico 1 semana', price: 'RD$ 2,000' },
            { name: 'Retoque de Petañas Volumen Tecnologico 2 semanas', price: 'RD$ 2,500' },
            { name: 'Retoque de Petañas Volumen Tecnologico 3 semanas', price: 'RD$ 3,000' }
          ]
        }
      ]
    },
    {
      service_name: 'Beauty Hair',
      service_slug: 'beauty-hair',
      service_image: 'assets/paomakeup/images/services/service-salon.jpeg',
      bgcolor: 'card3',
      sub_services: [
        {
          sub_service_name: 'Definición de Rizos',
          description: 'Incluye Lavado y Secado',
          services: [
            { name: 'Definicion de Rizos Extra Corto', price: 'RD$ 1,000' },
            { name: 'Definicion de Rizos Corto', price: 'RD$ 1,500' },
            { name: 'Definicion de Rizos Mediano/Largo', price: 'RD$ 2,000' },
            { name: 'Definicion de Rizos Extra Largo', price: 'RD$ 2,500' },
            { name: 'Definicion de Rizos Elaborado Corto', price: 'RD$ 1,900' },
            { name: 'Definicion de Rizos Elaborado Mediano/Largo', price: 'RD$ 2,400' },
            { name: 'Definicion de Rizos Elaborado Extra Largo', price: 'RD$ 2,900' },
          ]
        },
        {
          sub_service_name: 'Lavados y Secados',
          services: [
            { name: 'Lavado Pelo Corto', price: 'RD$ 400' },
            { name: 'Lavado Pelo Mediano/Largo', price: 'RD$ 500' },
            { name: 'Lavado Pelo Extra Largo', price: 'RD$ 600' },
            { name: 'Lavado y Secado Pelo Extra Corto', price: 'RD$ 600' },
            { name: 'Lavado y Secado Pelo Corto', price: 'RD$ 700' },
            { name: 'Lavado y Secado Pelo Mediano/Largo', price: 'RD$ 800' },
            { name: 'Lavado y Secado Pelo Extra Largo', price: 'RD$ 900' },
            { name: 'Secado de Pelo Corto', price: 'RD$ 500' },
            { name: 'Secado Pelo Mediano/Largo', price: 'RD$ 600' },
            { name: 'Secado Pelo Extra Largo', price: 'RD$ 700' }
          ]
        },
        {
          sub_service_name: 'Lavados con línea',
          description: 'No incluye secado - Incluye: Shampoo, Mascarilla, Leave In',
          services: [
            { name: 'Diamond Alfa Parf - Brillo e Hidratación', price: 'RD$ 500' },
            { name: 'Moroccanoil - Linea Hidratante', price: 'RD$ 700' },
            { name: 'DEYA - Hidratante', price: 'RD$ 500' },
            { name: 'MAKA - Antigrasa', price: 'RD$ 500' }
          ]
        },
        {
          sub_service_name: "Otros Tratamientos",
          services: [
            { name: "Postura Laciador", price: "RD$ 200" },
            { name: "Ampollas de Brillo Shine Boost Deya", price: "RD$ 350" },
            { name: "Ampollas para caida y fortalecimiento Strong Boost Deya", price: "RD$ 350" },
            { name: "Leave In Linea (Diamond, Moroccanoil, Deya, Maka)", price: "RD$ 300" },
            { name: "Tratamiento Linea (Morocannoil, Diamond, Deya, Maka)", price: "RD$ 500" },
            { name: "Mascarilla (Morocannoil, Diamond, Deya, Maka)", price: "RD$ 300" }
          ]
        },
        {
          sub_service_name: "Tratamientos profundos profesionales",
          description: "Incluye lavado y secado",
          services: [
            { name: "Botox Capilar Orgánico onz", price: "RD$ 2,500" },
            { name: "Cirugia Capilar DEYA onz", price: "RD$ 2,800" },
            { name: "Carbon Activo DEYA - Cabello corto", price: "RD$ 1,500" },
            { name: "Carbon Activo DEYA - Cabello Medio/Largo", price: "RD$ 2,000" },
            { name: "Carbon Activo DEYA - Cabello Extra Largo", price: "RD$ 2,500" }
          ]
        },
        {
          sub_service_name: "Cortes de Pelo",
          description: "No incluye secado",
          services: [
            { name: "Corte de Pollina", price: "RD$ 1,000" },
            { name: "Corte de Puntas", price: "RD$ 1,500" },
            { name: "Corte de Pelo con Diseño", price: "RD$ 2,500" },
            { name: "Split Ender Pro - Pelo Corto", price: "RD$ 1,000" },
            { name: "Split Ender Pro - Pelo Mediano/Largo", price: "RD$ 1,200" },
            { name: "Split Ender Pro - Pelo Largo", price: "RD$ 1,500" }
          ]
        },
        {
          sub_service_name: "Peinados, ondas y planchados",
          services: [
            { name: "Ondas Pelo Corto", price: "RD$ 800" },
            { name: "Ondas Pelo Mediano/Largo", price: "RD$ 1,000" },
            { name: "Ondas Pelo Extra Largo", price: "RD$ 1,500" },
            { name: "Ondas con Cepillo (Corto/Medio)", price: "RD$ 450" },
            { name: "Ondas con Cepillo (Largo/Extra largo)", price: "RD$ 500" },
            { name: "Peinado de Novia", price: "RD$ 2,000" },
            { name: "Peinado Elaborado", price: "RD$ 1,500" },
            { name: "Peinado Sencillo", price: "RD$ 1,000" },
            { name: "Prueba de Peinado de Novia", price: "RD$ 3,000" },
            { name: "Peinado Niña", price: "RD$ 800" },
            { name: "Planchado de Pelo Corto", price: "RD$ 400" },
            { name: "Planchado de Pelo Mediano/Largo", price: "RD$ 500" },
            { name: "Planchado de Pelo Extra/Largo", price: "RD$ 600" }
          ]
        },
        {
          sub_service_name: 'Procesos de color',
          description: 'Incluye lavado y secado',
          services: [
            { name: 'Tinte Completo Cabello Corto', price: 'RD$ 3,000' },
            { name: 'Tinte Completo Cabello Medio', price: 'RD$ 3,500' },
            { name: 'Tinte Completo Cabello Largo', price: 'RD$ 4,000' },
            { name: 'Tinte Completo Cabello Extra Largo', price: 'RD$ 6,000' },
            { name: 'Tinte Retoque Cintillo', price: 'RD$ 2,000' },
            { name: 'Tinte Retoque Raiz (para cubrir raiz o crecimiento)', price: 'RD$ 3,000' }
          ]
        }
      ]
    },
    {
      service_name: 'Beauty Face & Body',
      service_slug: 'beauty-face-body',
      service_image: 'assets/paomakeup/images/services/beauty-face.jpg',
      bgcolor: 'card4',
      sub_services: [
        {
          sub_service_name: 'Facial',
          description: 'Incluye limpieza facial, mascarilla y masaje facial',
          services: [
            { name: 'Spa de Ojos', price: 'RD$ 650'} ,
            { name: 'Facial Express * Sin Extracción', price: 'RD$ 1,500'} ,
            { name: 'Facial Detox', price: 'RD$ 2,500'} ,
            { name: 'Facial Limpieza Profunda', price: 'RD$ 3,500'} ,
            { name: 'Facial Hidratación Profunda', price: 'RD$ 3,500'} ,
          ]
        },
        {
          sub_service_name: 'Corporal',
          description: 'Incluye limpieza corporal, exfoliación, mascarilla y masaje corporal',
          services: [
            { name: 'Dermaplaning', price: 'RD$ 3,000'} ,
            { name: 'Hydralips', price: 'RD$ 4,500'} ,
            { name: 'Microneedling (Dermapen) ', price: 'RD$ 4,000'} ,
            { name: 'Peeling Químico', price: 'RD$ 2,000'} ,
            { name: 'Masaje Facial de Relajación', price: 'RD$ 500'} ,
            { name: 'Ampolla hidratante', price: 'RD$ 300'} ,
            { name: 'Peeling Corporal  ', price: 'RD$ 2,500'} ,
            { name: 'Blanqueamiento de Axilas', price: 'RD$ 1,500'} ,
          ]
        }
      ]
    },
    {
      service_name: 'Beauty Nails',
      service_slug: 'beauty-nails',
      service_image: 'assets/paomakeup/images/services/service-beauty-nails.jpg',
      bgcolor: 'card5',
      sub_services: [
        {
          sub_service_name: 'Manicure & Pedicure',
          description: 'Con sales relajantes de rosas. Incluye Pintura Normal',
          services: [
            { name: 'Manicure', price: 'RD$ 550' },
            { name: 'Pedicure', price: 'RD$ 750' },
            { name: 'Manicure Express en Seco (ideal para extensiones de uñas)', price: 'RD$ 400' },
            { name: 'Pedicure Express en Seco (ideal para extensiones de uñas)', price: 'RD$ 600' }
          ]
        },
        {
          sub_service_name: 'Pinturas',
          services: [
            { name: 'Pintura Normal Manos', price: 'RD$ 400' },
            { name: 'Pintura Normal Pies', price: 'RD$ 450' },
            { name: 'Pintura en Gel Caliente Manos', price: 'RD$ 600' },
            { name: 'Pintura en Gel Caliente Pies', price: 'RD$ 700' },
            { name: 'Pintura en Gel Frio Manos', price: 'RD$ 500' },
            { name: 'Pintura en Gel Frio Pies', price: 'RD$ 550' },
            { name: 'Retiro de Gel Pies', price: 'RD$ 400' },
            { name: 'Retiro Gel Manos', price: 'RD$ 300' }
          ]
        },
        {
          sub_service_name: 'Diseños',
          services: [
            { name: 'French Regular', price: 'RD$ 200' },
            { name: 'French Gel', price: 'RD$ 300' },
            { name: 'Diseño con Piedras 1 uña', price: 'RD$ 200' },
            { name: 'Diseño con Piedras - Full Set', price: 'RD$ 1,000' }
          ]
        },
        {
          sub_service_name: 'Gel Builder Cuccio*',
          description: 'Incluye manicure y pintura regular. Con vitaminas y calcio para fortalecer las uñas',
          services: [
            { name: 'Full Set', price: 'RD$ 2,200' },
            { name: 'Retoque', price: 'RD$ 1,700' },
            { name: 'Reparación 1 uña', price: 'RD$ 250' },
            { name: 'Retiro', price: 'RD$ 400' }
          ]
        },
        {
          sub_service_name: 'Press On - extensiones de uñas',
          description: 'Incluye manicure express. Sistema sin olor que fortalece las uñas',
          services: [
            { name: 'Full Set', price: 'RD$ 2,500' },
            { name: 'Retoque', price: 'RD$ 1,500' },
            { name: 'Reparación 1 uña', price: 'RD$ 300' },
            { name: 'Retiro', price: 'RD$ 400' }
          ]
        },
        {
          sub_service_name: 'Otros',
          services: [
            { name: 'Mascarilla de Manos', price: 'RD$ 400' },
            { name: 'Mascarilla de Pies', price: 'RD$ 500' },
            { name: 'Masaje Relax Pies - 20mins', price: 'RD$ 600' },
            { name: 'Masaje Relax Manos - 20mins', price: 'RD$ 500' },
            { name: 'Spa de Pies (Incluye pedi, masaje y mascarilla)', price: 'RD$ 1,650' },
            { name: 'Spa de Manos (Incluye mani, masaje y mascarilla)', price: 'RD$ 1,350' }
          ]
        }
      ]
    }
  ],
  homepage_carousel: [
    {
      id: 1,
      image: '../assets/paomakeup/images/services/microblading.jpg',
      alt: 'Permanent Makeup',
      title: 'Permanent Makeup',
      description: 'Te imaginas no tener que maquillarte a diario? Esto es posible con nuestros procedimientos de maquillaje semipermanente y podrás tener unas cejas perfectas y con un aspecto muy natural.'
    },
    {
      id: 2,
      image: '../assets/paomakeup/images/services/maquillaje-cliente.jpg',
      alt: 'Makeup',
      title: 'Maquillaje',
      description: 'Descubre el arte del maquillaje que resalta tu belleza intrínseca.\nYa sea para una ocasión especial o un look diario, te guiaremos hacia la perfección en cada trazo y color.'
    },
    {
      id: 3,
      image: '../assets/paomakeup/images/services/pestanas.jpg',
      alt: 'Beauty Lashes',
      title: 'Beauty Lashes',
      description: 'Eleva tu mirada con nuestras extensiones de pestañas. Desde un toque sutil hasta un glamour completo, cada pestaña cuenta una historia de elegancia.'
    },
    {
      id: 4,
      image: '../assets/paomakeup/images/services/salon-belleza.jpg',
      alt: 'Salón de Belleza',
      title: 'Salón de Belleza',
      description: 'Sumérgete en nuestro salón de belleza. Un santuario donde la relajación se combina con la transformación, servicios excepcionales que realzan tu belleza.'
    },
    {
      id: 5,
      image: '../assets/paomakeup/images/services/service-beauty-nails.jpg',
      alt: 'Manicure y Pedicure',
      title: 'Manicure y Pedicure',
      description: 'Disfruta de un momento de relajación y cuidado personal con nuestros servicios de manicure y pedicure. Tus manos y pies merecen el mejor trato, y nosotros te lo ofrecemos con productos naturales y técnicas especializadas.'
    }
  ],
  address: 'Calle Juan Isidro Ortega #302, Los Prados' +
      '\n' +
      'Santo Domingo, DN\n' +
      '\n' +
      'República Dominicana',
  phone: '809-547-4779',
  whatsapp: '829-729-4779',
  email: 'info@paomakeup.com',
  facebook: 'https://www.facebook.com/PaoMakeupBeautyStudio/?ref=br_rs',
  twitter: '',
  instagram: 'https://www.instagram.com/paomakeupstudio',
  linkedin: '',
  youtube: 'https://www.youtube.com/channel/UCLzJpdrplA9Oy6K1tVf8ZHw',
  tiktok: 'https://www.tiktok.com/paomakeup',
  // Add more data as needed
};

export default data;
